module.exports = __webpack_public_path__ + "static/media/Pin.4039a69f.svg";